<template>
  <div class="sheet-menu-item" role="button">
    <div class="sheet-menu-item__content">
      <img :src="image" alt="icon" class="sheet-menu-item__icon" />
      <div class="sheet-menu-item__text">{{ title }}</div>
      <div class="sheet-menu-item__arrow"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppBaseSheetMenuItem",
  props: {
    image: {
      type: [Object, String],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="less">
.sheet-menu-item {
  background: linear-gradient(180deg, #313944 0%, rgba(49, 57, 68, 0) 128.66%);
  opacity: 0.8;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 15px;
  margin-bottom: 16px;

  &__content {
    margin: 8px;
    display: flex;
    align-items: center;
  }

  &__icon {
    width: 99px;
    height: 44px;
    object-fit: cover;
    border-radius: 8px;
    margin-right: 12px;
  }

  &__text {
    flex: 1;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    letter-spacing: 0.01em;
    color: #ffffff;
  }

  &__arrow {
    width: 18px;
    height: 18px;
    background: url(@/assets/sheets/app-right-arrow.svg) no-repeat center;
  }
}
</style>
